<template>
    <div>
        <v-card elevation="0">
            <v-card color="#33675E" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-view-grid-plus-outline</v-icon>
                    &nbsp;Browse Postings
                </v-card-title>
            </v-card>
            <v-card-text>
                <Search />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Search from "../../../components/Applicants/BrowsePostings/Search.vue"
export default {
    components: {
        Search
    }
}
</script>